<script setup lang="ts">
import { readItems } from '@directus/sdk';

const { cms, convertAssetUrls } = useCms();

const { data: partners } = await useAsyncData(
  'cmla_2024_conference_partners',
  async () => {
    const data = await cms.request(
      readItems('cmla_2024_conference_partners', {
        fields: ['*', 'image.*'],
        sort: 'sort',
      }),
    );
    return data.map((x) => {
      return convertAssetUrls(x, ['image']);
    });
  },
);

const supporting = computed(() => {
  return partners.value?.filter((x) => x.type === 'Supporting');
});

const coOrganizers = computed(() => {
  return partners.value?.filter((x) => x.type === 'Co-Organizer');
});
</script>

<template>
  <section>
    <div class="container">
      <div class="heading">Co-Organizers</div>
      <div class="row g-5">
        <template v-for="partner in coOrganizers">
          <div class="col-lg-4 col-6">
            <a :href="partner.href" target="_blank" class="caption">
              {{ partner.name }}
            </a>
            <img v-if="partner.image" :src="partner.image" />
          </div>
        </template>
      </div>
      <div class="heading">Supporting Organizations</div>
      <div class="row g-5">
        <template v-for="partner in supporting">
          <div class="col-lg-4 col-6">
            <a :href="partner.href" target="_blank" class="caption">
              {{ partner.name }}
            </a>
            <img v-if="partner.image" :src="partner.image" />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

section {
  background: #f1f1f1;
  padding: 144px 16px;

  .heading {
    color: $primary;
    font-size: 40px;
    font-weight: 700;
    margin: 1em 0;
  }

  .caption {
    font-size: 18px;
    font-weight: 500;
    margin: 1em 0;
    display: block;
  }

  img {
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: contain;
  }
}
</style>
